<template>
  <div class="x-tablelist-view myline" data-automation="myLine">
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        class="myline-table"
        layout="total, sizes, prev, pager, next"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns1"
        :size="filter.size"
        :page="filter.page"
        :emptyText="$t('HT.nodata')"
        @changePage="changePage"
        @changeSize="changeSize"
      ></ux-table>
    </div>

    <purchase-api
      :product="modalData.purchaseApi.product"
      v-if="modalData.purchaseApi.isShow"
      :product-remark="modalData.purchaseApi.productRemark"
      @close="modalData.purchaseApi.isShow = false"
      @update-list="updateList"
    ></purchase-api>
  </div>
</template>

<script>
import purchaseApi from './modal/purchaseApi';

// import topUp from './template/topUp';
export default {
  components: {
    purchaseApi
  },
  data() {
    return {
      modalData: {
        purchaseApi: {
          isShow: false,
          productRemark: '', // 产品描述
          product: null
        }
      },
      // 表的数据
      tableData: {
        list: []
      },
      filter: {
        // 查询参数
        name: '', // 应用名称
        page: 1,
        size: 10
      },
      columns1: [
        // 表格项
        {
          label: this.$t('HT.purchaseApi.productName'),
          align: 'left',
          tooltip: true,
          prop: 'product_name'
        },
        {
          label: this.$t('HT.myline.usedQuota'),
          align: 'left',
          tooltip: true,
          prop: 'used_quota'
        },
        {
          label: this.$t('HT.myline.remainQuota'),
          align: 'left',
          tooltip: true,
          prop: 'remain_quota'
        },
        {
          label: this.$t('HT.myline.percentage'),
          align: 'left',
          tooltip: true,
          render: (h, params) => {
            const { used_quota, total } = params;
            let percentage = 100;
            if (total > 0) {
              percentage = Math.floor(used_quota / total * 100);
            }
            return h('UxProgress', {
              attrs: {
                style: 'padding-right: 10px'
              },
              props: {
                percentage
              }
            });
          }
        },
        {
          label: this.$t('HT.myline.maxLimit'),
          align: 'left',
          tooltip: true,
          prop: 'max_limit'
        },
        {
          label: this.$t('HT.operation'),
          align: 'left',
          hidden: !this.$hasModule(6),
          render: (h, params) => {
            return h(
              'UxButton',
              {
                props: {
                  type: 'primary',
                  text: true
                },
                on: {
                  click: () => {
                    console.log(params);
                    const purchaseApi = {
                      product: params,
                      productRemark: params.product_remark || '',
                      isShow: true
                    };
                    this.$set(this.modalData, 'purchaseApi', purchaseApi);
                  }
                }
              },
              this.$t('HT.purchaseApi.title')
            );
          }
        }
      ]
    };
  },
  created() {
    this.getList(this.filter);
  },
  mounted() {
    // document.querySelector('.myline-table .ux-pagination').classList.remove('is-background');
  },
  methods: {
    // 刷新列表
    updateList() {
      this.getList(this.filter);
    },
    /**
     * @description: 修改额度
     * @param {id,value} :id 额度id  value 充值额度
     */
    changeLine(id, value) {
      this.$uxLoading.show();
      this.$api.myline.gettopLine(id, { quota: value - 0 }).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.rechargedSuccess'));
          this.getList(this.filter);
        }
      });
    },
    /**
     * @description: 获取产品额度分页列表
     * @param {params} : 请求分页数据
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.myline.getList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            list: res.data.map((item) => {
              return {
                id: item.id,
                index: item.index,
                max_limit: item.max_limit,
                quota: item.quota,
                peak_value: item.peak_value,
                product_id: item.product_id,
                product_name: item.product_name,
                //可用额度
                used_quota: item.used_quota,
                product_remark: item.product_remark,

                // 剩余额度
                remain_quota: item.remain_quota,

                //[剩余额度,并发上限]
                remainQuota: [
                  { remark: item.remain_quota + this.$t('HT.myline.number'), env: 'RET' },
                  { remark: item.max_limit + 'QPS', env: 'MOSTLIMIT' }
                ],
                // [已用额度,并发峰值]
                usedQuota: [
                  { remark: item.used_quota + this.$t('HT.myline.number'), env: 'USED' },
                  { remark: item.peak_value + 'QPS', env: 'MOSTVALUE' }
                ],
                total: item.total
              };
            })
          };
        }
      });
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>

<style lang="scss" scoped>
.x-tablelist-view.myline {
  height: 100%;
  margin: 0;
  background: none;
  border: none;
  padding: 20px 40px 0 20px;
}

::v-deep .myline-table .ux-pagination {
  text-align: right;
  padding: 20px 0 32px;

  .btn-next,
  .btn-prev {
    height: 32px;
    background: transparent;
  }

  .el-pager {
    .el-icon-more,
    .number,
    .btn-quicknext:hover {
      height: 32px;
      line-height: 32px;
      background: transparent;
    }
  }

  .el-pagination__sizes .el-select .el-input {
    .el-input__inner {
      border: none;
      background: transparent;
    }
  }
}
</style>
